import { render, staticRenderFns } from "./block-file-component.vue?vue&type=template&id=dc2dea44&scoped=true&"
import script from "./block-file-component.vue?vue&type=script&lang=ts&"
export * from "./block-file-component.vue?vue&type=script&lang=ts&"
import style0 from "./block-file-component.vue?vue&type=style&index=0&id=dc2dea44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2dea44",
  null
  
)

export default component.exports